/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 * THIS FILE IS AN AUTOGENERATED TYPESCRIPT PROXY EXTENSION.
 * TO USE THIS FILE, IT MUST BE ADDED TO A D365COMMERCE APPLICATION
 */
import {
    AsyncResult,
    callActionOrExecute,
    DataServiceQuery,
    IContext,
    IDataServiceRequest,
    IQueryResultSettings,
    // @ts-ignore -- Unused import
    NullResult
} from '@msdyn365-commerce/retail-proxy';
// @ts-ignore -- Unused import
import * as EntityClasses from '@msdyn365-commerce/retail-proxy/dist/Entities/CommerceModels.g';
// @ts-ignore -- Unused import
import * as Entities from '@msdyn365-commerce/retail-proxy/dist/Entities/CommerceTypes.g';
import * as DataServiceEntities from './DataServiceEntities.g';

function getAzureBlobStorageSASTokenQuery(): DataServiceQuery {
    return new DataServiceQuery();
}

export function getAzureBlobStorageSASTokenInput(): IDataServiceRequest {
    const query = getAzureBlobStorageSASTokenQuery();
    return query.createDataServiceRequestForOperation(
        'GetAzureBlobStorageSASToken',
        false,
        DataServiceEntities.GetAzureBlobStorageSASTokenResponseExtensionClass,
        'false',
        { bypassCache: 'get', returnEntity: 'DataServiceEntities.IGetAzureBlobStorageSASTokenResponse' },
        {}
    );
}

export function getAzureBlobStorageSASTokenAsync(context: IContext): AsyncResult<DataServiceEntities.IGetAzureBlobStorageSASTokenResponse> {
    const request = getAzureBlobStorageSASTokenInput();
    return callActionOrExecute<DataServiceEntities.IGetAzureBlobStorageSASTokenResponse>(request, context.callerContext);
}

function validateOrganizationQuery(): DataServiceQuery {
    return new DataServiceQuery();
}

export function validateOrganizationInput(accountNum: string, email: string, zipCode: string, street: string): IDataServiceRequest {
    const query = validateOrganizationQuery();
    return query.createDataServiceRequestForOperation(
        'ValidateOrganization',
        true,
        DataServiceEntities.ValidateOrganizationResponseExtensionClass,
        'false',
        { bypassCache: 'get', returnEntity: 'DataServiceEntities.IValidateOrganizationResponse' },
        {
            accountNum: accountNum,
            email: email,
            zipCode: zipCode,
            street: street
        }
    );
}

export function validateOrganizationAsync(
    context: IContext,
    accountNum: string,
    email: string,
    zipCode: string,
    street: string
): AsyncResult<DataServiceEntities.IValidateOrganizationResponse> {
    const request = validateOrganizationInput(accountNum, email, zipCode, street);
    return callActionOrExecute<DataServiceEntities.IValidateOrganizationResponse>(request, context.callerContext);
}

function createExistingCustomerUserQuery(): DataServiceQuery {
    return new DataServiceQuery();
}

export function createExistingCustomerUserInput(
    accountNum: string,
    firstName: string,
    lastName: string,
    businessEmailAddress: string,
    marketingOptInPhone: boolean,
    marketingOptInEmail: boolean,
    phoneNumber: string
): IDataServiceRequest {
    const query = createExistingCustomerUserQuery();
    return query.createDataServiceRequestForOperation(
        'CreateExistingCustomerUser',
        true,
        DataServiceEntities.ExistingCustomerUserCreationResponseExtensionClass,
        'false',
        { bypassCache: 'get', returnEntity: 'DataServiceEntities.IExistingCustomerUserCreationResponse' },
        {
            accountNum: accountNum,
            firstName: firstName,
            lastName: lastName,
            businessEmailAddress: businessEmailAddress,
            marketingOptInPhone: marketingOptInPhone,
            marketingOptInEmail: marketingOptInEmail,
            phoneNumber: phoneNumber
        }
    );
}

export function createExistingCustomerUserAsync(
    context: IContext,
    accountNum: string,
    firstName: string,
    lastName: string,
    businessEmailAddress: string,
    marketingOptInPhone: boolean,
    marketingOptInEmail: boolean,
    phoneNumber: string
): AsyncResult<DataServiceEntities.IExistingCustomerUserCreationResponse> {
    const request = createExistingCustomerUserInput(
        accountNum,
        firstName,
        lastName,
        businessEmailAddress,
        marketingOptInPhone,
        marketingOptInEmail,
        phoneNumber
    );
    return callActionOrExecute<DataServiceEntities.IExistingCustomerUserCreationResponse>(request, context.callerContext);
}

function createUniqueProspectQuery(): DataServiceQuery {
    return new DataServiceQuery();
}

export function createUniqueProspectInput(businessPartnerProspect: Entities.BusinessPartnerProspect): IDataServiceRequest {
    const query = createUniqueProspectQuery();
    return query.createDataServiceRequestForOperation(
        'CreateUniqueProspect',
        true,
        DataServiceEntities.CreateUniqueProspectResponseExtensionClass,
        'false',
        { bypassCache: 'get', returnEntity: 'DataServiceEntities.ICreateUniqueProspectResponse' },
        {
            businessPartnerProspect: businessPartnerProspect
        }
    );
}

export function createUniqueProspectAsync(
    context: IContext,
    businessPartnerProspect: Entities.BusinessPartnerProspect
): AsyncResult<DataServiceEntities.ICreateUniqueProspectResponse> {
    const request = createUniqueProspectInput(businessPartnerProspect);
    return callActionOrExecute<DataServiceEntities.ICreateUniqueProspectResponse>(request, context.callerContext);
}

function getOrgTypeCustomerQuery(): DataServiceQuery {
    return new DataServiceQuery();
}

function shareOrderListQuery(): DataServiceQuery {
    return new DataServiceQuery();
}

export function shareOrderListInput(productListId: string, emailAddress: string): IDataServiceRequest {
    const query = shareOrderListQuery();
    return query.createDataServiceRequestForOperation(
        'ShareOrderList',
        true,
        DataServiceEntities.SendOrderListResponseExtensionClass,
        'false',
        { bypassCache: 'get', returnEntity: 'DataServiceEntities.ISendOrderListResponse' },
        {
            productListId: productListId,
            emailAddress: emailAddress
        }
    );
}

export function shareOrderListAsync(
    context: IContext,
    productListId: string,
    emailAddress: string
): AsyncResult<DataServiceEntities.ISendOrderListResponse> {
    const request = shareOrderListInput(productListId, emailAddress);
    return callActionOrExecute<DataServiceEntities.ISendOrderListResponse>(request, context.callerContext);
}

export function getOrgTypeCustomerInput(businessPartnerID: string): IDataServiceRequest {
    const query = getOrgTypeCustomerQuery();
    return query.createDataServiceRequestForOperation(
        'GetOrgTypeCustomer',
        true,
        DataServiceEntities.GetOrgTypeCustomerResponseExtensionClass,
        'false',
        { bypassCache: 'get', returnEntity: 'DataServiceEntities.IGetOrgTypeCustomerResponse' },
        {
            businessPartnerID: businessPartnerID
        }
    );
}

export function getOrgTypeCustomerAsync(
    context: IContext,
    businessPartnerID: string
): AsyncResult<DataServiceEntities.IGetOrgTypeCustomerResponse> {
    const request = getOrgTypeCustomerInput(businessPartnerID);
    return callActionOrExecute<DataServiceEntities.IGetOrgTypeCustomerResponse>(request, context.callerContext);
}

function custBlobFileNameAttachmentQuery(): DataServiceQuery {
    return new DataServiceQuery();
}

export function custBlobFileNameAttachmentInput(accountNum: string, taxStatus: string, blobFileName: string): IDataServiceRequest {
    const query = custBlobFileNameAttachmentQuery();
    return query.createDataServiceRequestForOperation(
        'CustBlobFileNameAttachment',
        true,
        DataServiceEntities.CustBlobFileNameAttachmentResponseExtensionClass,
        'false',
        { bypassCache: 'get', returnEntity: 'DataServiceEntities.ICustBlobFileNameAttachmentResponse' },
        {
            accountNum: accountNum,
            taxStatus: taxStatus,
            blobFileName: blobFileName
        }
    );
}

export function custBlobFileNameAttachmentAsync(
    context: IContext,
    accountNum: string,
    taxStatus: string,
    blobFileName: string
): AsyncResult<DataServiceEntities.ICustBlobFileNameAttachmentResponse> {
    const request = custBlobFileNameAttachmentInput(accountNum, taxStatus, blobFileName);
    return callActionOrExecute<DataServiceEntities.ICustBlobFileNameAttachmentResponse>(request, context.callerContext);
}

function custDocusignAttachmentQuery(): DataServiceQuery {
    return new DataServiceQuery();
}

export function custDocusignAttachmentInput(
    accountNum: string,
    taxStatus: string,
    webFormID: string,
    webFormInstanceID: string
): IDataServiceRequest {
    const query = custDocusignAttachmentQuery();
    return query.createDataServiceRequestForOperation(
        'CustDocusignAttachment',
        true,
        DataServiceEntities.CustDocusignAttachmentResponseExtensionClass,
        'false',
        { bypassCache: 'get', returnEntity: 'DataServiceEntities.ICustDocusignAttachmentResponse' },
        {
            accountNum: accountNum,
            taxStatus: taxStatus,
            webFormID: webFormID,
            webFormInstanceID: webFormInstanceID
        }
    );
}

export function custDocusignAttachmentAsync(
    context: IContext,
    accountNum: string,
    taxStatus: string,
    webFormID: string,
    webFormInstanceID: string
): AsyncResult<DataServiceEntities.ICustDocusignAttachmentResponse> {
    const request = custDocusignAttachmentInput(accountNum, taxStatus, webFormID, webFormInstanceID);
    return callActionOrExecute<DataServiceEntities.ICustDocusignAttachmentResponse>(request, context.callerContext);
}

function taxExemptionCheckQuery(): DataServiceQuery {
    return new DataServiceQuery();
}

export function taxExemptionCheckInput(state: string, styleOfBusiness: string): IDataServiceRequest {
    const query = taxExemptionCheckQuery();
    return query.createDataServiceRequestForOperation(
        'TaxExemptionCheck',
        true,
        DataServiceEntities.TaxExemptionCheckResponseExtensionClass,
        'false',
        { bypassCache: 'get', returnEntity: 'DataServiceEntities.ITaxExemptionCheckResponse' },
        {
            state: state,
            styleOfBusiness: styleOfBusiness
        }
    );
}

export function taxExemptionCheckAsync(
    context: IContext,
    state: string,
    styleOfBusiness: string
): AsyncResult<DataServiceEntities.ITaxExemptionCheckResponse> {
    const request = taxExemptionCheckInput(state, styleOfBusiness);
    return callActionOrExecute<DataServiceEntities.ITaxExemptionCheckResponse>(request, context.callerContext);
}

function getUOMDefinitionQuery(): DataServiceQuery {
    return new DataServiceQuery();
}

export function getUOMDefinitionInput(itemID: string, productRECID: number, fromUnit: string, toUnit: string): IDataServiceRequest {
    const query = getUOMDefinitionQuery();
    return query.createDataServiceRequestForOperation(
        'GetUOMDefinition',
        true,
        DataServiceEntities.GetUOMDefinitionResponseExtensionClass,
        'false',
        { bypassCache: 'get', returnEntity: 'DataServiceEntities.IGetUOMDefinitionResponse' },
        {
            itemID: itemID,
            productRECID: productRECID,
            fromUnit: fromUnit,
            toUnit: toUnit
        }
    );
}

export function getUOMDefinitionAsync(
    context: IContext,
    itemID: string,
    productRECID: number,
    fromUnit: string,
    toUnit: string
): AsyncResult<DataServiceEntities.IGetUOMDefinitionResponse> {
    const request = getUOMDefinitionInput(itemID, productRECID, fromUnit, toUnit);
    return callActionOrExecute<DataServiceEntities.IGetUOMDefinitionResponse>(request, context.callerContext);
}

// @ts-ignore
function docuSignQuery(email?: string): DataServiceQuery {
    const key = email ? { Email: email } : null;
    return new DataServiceQuery(
        'DocuSign',
        'TaxFormPreFilledFieldsEntity',
        DataServiceEntities.TaxFormPreFilledFieldsEntityExtensionClass,
        key
    );
}

export function createRefreshWebFormInstanceTokenInput(formID: string, formInstanceID: string): IDataServiceRequest {
    const query = docuSignQuery();
    return query.createDataServiceRequestForOperation(
        'RefreshWebFormInstanceToken',
        true,
        DataServiceEntities.RefreshWebFormInstanceTokenResponseExtensionClass,
        'false',
        { bypassCache: 'get', returnEntity: 'DataServiceEntities.IRefreshWebFormInstanceTokenResponse' },
        { formID: formID, formInstanceID: formInstanceID }
    );
}

export function refreshWebFormInstanceTokenAsync(
    context: IContext,
    formID: string,
    formInstanceID: string
): AsyncResult<DataServiceEntities.IRefreshWebFormInstanceTokenResponse> {
    const request = createRefreshWebFormInstanceTokenInput(formID, formInstanceID);
    return callActionOrExecute<DataServiceEntities.IRefreshWebFormInstanceTokenResponse>(request, context.callerContext);
}

export function createCreateWebFormInstanceTokenInput(
    preFilledFields: DataServiceEntities.ITaxFormPreFilledFieldsEntity
): IDataServiceRequest {
    const query = docuSignQuery();
    return query.createDataServiceRequestForOperation(
        'CreateWebFormInstanceToken',
        true,
        DataServiceEntities.CreateWebFormInstanceTokenResponseExtensionClass,
        'false',
        { bypassCache: 'get', returnEntity: 'DataServiceEntities.ICreateWebFormInstanceTokenResponse' },
        { preFilledFields: preFilledFields }
    );
}

export function createWebFormInstanceTokenAsync(
    context: IContext,
    preFilledFields: DataServiceEntities.ITaxFormPreFilledFieldsEntity
): AsyncResult<DataServiceEntities.ICreateWebFormInstanceTokenResponse> {
    const request = createCreateWebFormInstanceTokenInput(preFilledFields);
    return callActionOrExecute<DataServiceEntities.ICreateWebFormInstanceTokenResponse>(request, context.callerContext);
}

export function createCreateDefaultFormInstanceTokenInput(
    preFilledFields: DataServiceEntities.ITaxFormPreFilledFieldsEntity
): IDataServiceRequest {
    const query = docuSignQuery();
    return query.createDataServiceRequestForOperation(
        'CreateDefaultFormInstanceToken',
        true,
        DataServiceEntities.CreateWebFormInstanceTokenResponseExtensionClass,
        'false',
        { bypassCache: 'get', returnEntity: 'DataServiceEntities.ICreateWebFormInstanceTokenResponse' },
        { preFilledFields: preFilledFields }
    );
}

export function createDefaultFormInstanceTokenAsync(
    context: IContext,
    preFilledFields: DataServiceEntities.ITaxFormPreFilledFieldsEntity
): AsyncResult<DataServiceEntities.ICreateWebFormInstanceTokenResponse> {
    const request = createCreateDefaultFormInstanceTokenInput(preFilledFields);
    return callActionOrExecute<DataServiceEntities.ICreateWebFormInstanceTokenResponse>(request, context.callerContext);
}

// @ts-ignore
function storeSelectionQuery(customerAccountNumber?: string): DataServiceQuery {
    const key = customerAccountNumber ? { CustomerAccountNumber: customerAccountNumber } : null;
    return new DataServiceQuery('StoreSelection', 'PreferredStoreEntity', DataServiceEntities.PreferredStoreEntityExtensionClass, key);
}

export function createGetPreferredStoreInput(custAccNumber: string): IDataServiceRequest {
    const query = storeSelectionQuery();
    return query.createDataServiceRequestForOperation(
        'GetPreferredStore',
        true,
        DataServiceEntities.PreferredStoreEntityExtensionClass,
        'false',
        { bypassCache: 'none', returnEntity: 'DataServiceEntities.IPreferredStoreEntity' },
        { custAccNumber: custAccNumber }
    );
}

export function getPreferredStoreAsync(context: IContext, custAccNumber: string): AsyncResult<DataServiceEntities.IPreferredStoreEntity> {
    const request = createGetPreferredStoreInput(custAccNumber);
    return callActionOrExecute<DataServiceEntities.IPreferredStoreEntity>(request, context.callerContext);
}

export function createAddPreferredStoreInput(preferredStore: DataServiceEntities.IPreferredStoreEntity): IDataServiceRequest {
    const query = storeSelectionQuery();
    return query.createDataServiceRequestForOperation(
        'AddPreferredStore',
        true,
        DataServiceEntities.AddPreferredStoreResponseExtensionClass,
        'false',
        { bypassCache: 'get', returnEntity: 'DataServiceEntities.IAddPreferredStoreResponse' },
        { preferredStore: preferredStore }
    );
}

export function addPreferredStoreAsync(
    context: IContext,
    preferredStore: DataServiceEntities.IPreferredStoreEntity
): AsyncResult<DataServiceEntities.IAddPreferredStoreResponse> {
    const request = createAddPreferredStoreInput(preferredStore);
    return callActionOrExecute<DataServiceEntities.IAddPreferredStoreResponse>(request, context.callerContext);
}

// @ts-ignore
function purchaseHistoryQuery(recID?: number): DataServiceQuery {
    const key = recID ? { RecID: recID } : null;
    return new DataServiceQuery(
        'PurchaseHistory',
        'PurchaseHistoryProductEntity',
        DataServiceEntities.PurchaseHistoryProductEntityExtensionClass,
        key
    );
}

export function createGetProductsInput(
    queryResultSettings: IQueryResultSettings,
    orgPurchaseHistory: boolean,
    businessPartnerID: string,
    accountNum: string
): IDataServiceRequest {
    const query = purchaseHistoryQuery().resultSettings(queryResultSettings);
    return query.createDataServiceRequestForOperation(
        'GetProducts',
        true,
        DataServiceEntities.PurchaseHistoryProductEntityExtensionClass,
        'true',
        { bypassCache: 'none', returnEntity: 'DataServiceEntities.IPurchaseHistoryProductEntity' },
        { orgPurchaseHistory: orgPurchaseHistory, businessPartnerID: businessPartnerID, accountNum: accountNum }
    );
}

export function getProductsAsync(
    context: IContext,
    orgPurchaseHistory: boolean,
    businessPartnerID: string,
    accountNum: string
): AsyncResult<DataServiceEntities.IPurchaseHistoryProductEntity[]> {
    const request = createGetProductsInput(context.queryResultSettings || {}, orgPurchaseHistory, businessPartnerID, accountNum);
    return callActionOrExecute<DataServiceEntities.IPurchaseHistoryProductEntity[]>(request, context.callerContext);
}

// @ts-ignore
function styleOfBusinessQuery(rECID?: number): DataServiceQuery {
    const key = rECID ? { RECID: rECID } : null;
    return new DataServiceQuery('StyleOfBusiness', 'StyleOfBusinessEntity', DataServiceEntities.StyleOfBusinessEntityExtensionClass, key);
}

export function createGetAllStylesOfBusinessInput(queryResultSettings: IQueryResultSettings): IDataServiceRequest {
    const query = styleOfBusinessQuery().resultSettings(queryResultSettings);
    return query.createDataServiceRequestForOperation(
        'GetAllStylesOfBusiness',
        false,
        DataServiceEntities.StyleOfBusinessEntityExtensionClass,
        'true',
        { bypassCache: 'none', returnEntity: 'DataServiceEntities.IStyleOfBusinessEntity' },
        {}
    );
}

export function getAllStylesOfBusinessAsync(context: IContext): AsyncResult<DataServiceEntities.IStyleOfBusinessEntity[]> {
    const request = createGetAllStylesOfBusinessInput(context.queryResultSettings || {});
    return callActionOrExecute<DataServiceEntities.IStyleOfBusinessEntity[]>(request, context.callerContext);
}

// @ts-ignore
function safeDropReportQuery(transactionId?: string): DataServiceQuery {
    const key = transactionId ? { TransactionId: transactionId } : null;
    return new DataServiceQuery('SafeDropReport', 'SafeDropEntity', DataServiceEntities.SafeDropEntityExtensionClass, key);
}

export function createSafeDropReportDataSetInput(reportId: string, reportParameters: Entities.CommerceProperty[]): IDataServiceRequest {
    const query = safeDropReportQuery();
    return query.createDataServiceRequestForOperation(
        'SafeDropReportDataSet',
        true,
        EntityClasses.ReportDataSetClass,
        'false',
        { bypassCache: 'get', returnEntity: 'Entities.ReportDataSet' },
        { reportId: reportId, reportParameters: reportParameters }
    );
}

export function safeDropReportDataSetAsync(
    context: IContext,
    reportId: string,
    reportParameters: Entities.CommerceProperty[]
): AsyncResult<Entities.ReportDataSet> {
    const request = createSafeDropReportDataSetInput(reportId, reportParameters);
    return callActionOrExecute<Entities.ReportDataSet>(request, context.callerContext);
}

export function createPrintSafeDropReportInput(printType: string, reportDataSet: Entities.ReportDataSet): IDataServiceRequest {
    const query = safeDropReportQuery();
    return query.createDataServiceRequestForOperation(
        'PrintSafeDropReport',
        true,
        DataServiceEntities.PrintSafeDropReportMessageResponseExtensionClass,
        'false',
        { bypassCache: 'get', returnEntity: 'DataServiceEntities.IPrintSafeDropReportMessageResponse' },
        { printType: printType, reportDataSet: reportDataSet }
    );
}

export function printSafeDropReportAsync(
    context: IContext,
    printType: string,
    reportDataSet: Entities.ReportDataSet
): AsyncResult<DataServiceEntities.IPrintSafeDropReportMessageResponse> {
    const request = createPrintSafeDropReportInput(printType, reportDataSet);
    return callActionOrExecute<DataServiceEntities.IPrintSafeDropReportMessageResponse>(request, context.callerContext);
}

export function createSearchStoresInput(queryResultSettings: IQueryResultSettings): IDataServiceRequest {
    const query = safeDropReportQuery().resultSettings(queryResultSettings);
    return query.createDataServiceRequestForOperation(
        'SearchStores',
        false,
        EntityClasses.OrgUnitClass,
        'true',
        { bypassCache: 'none', returnEntity: 'Entities.OrgUnit' },
        {}
    );
}

export function searchStoresAsync(context: IContext): AsyncResult<Entities.OrgUnit[]> {
    const request = createSearchStoresInput(context.queryResultSettings || {});
    return callActionOrExecute<Entities.OrgUnit[]>(request, context.callerContext);
}

// @ts-ignore
function xZReportQuery(transactionId?: string): DataServiceQuery {
    const key = transactionId ? { TransactionId: transactionId } : null;
    return new DataServiceQuery('XZReport', 'XZReportEntity', DataServiceEntities.XZReportEntityExtensionClass, key);
}

export function createXReportExcelInput(reportType: number, shift: Entities.Shift): IDataServiceRequest {
    const query = xZReportQuery();
    return query.createDataServiceRequestForOperation(
        'XReportExcel',
        true,
        '',
        'false',
        { bypassCache: 'get', returnEntity: '' },
        { reportType: reportType, shift: shift }
    );
}

export function xReportExcelAsync(context: IContext, reportType: number, shift: Entities.Shift): AsyncResult<string> {
    const request = createXReportExcelInput(reportType, shift);
    return callActionOrExecute<string>(request, context.callerContext);
}

export function createZReportExcelInput(reportType: number): IDataServiceRequest {
    const query = xZReportQuery();
    return query.createDataServiceRequestForOperation(
        'ZReportExcel',
        true,
        '',
        'false',
        { bypassCache: 'get', returnEntity: '' },
        { reportType: reportType }
    );
}

export function zReportExcelAsync(context: IContext, reportType: number): AsyncResult<string> {
    const request = createZReportExcelInput(reportType);
    return callActionOrExecute<string>(request, context.callerContext);
}

function generateOtpQuery(): DataServiceQuery {
    return new DataServiceQuery();
}

export function generateOtpInput(emailAddress: string): IDataServiceRequest {
    const query = generateOtpQuery();
    return query.createDataServiceRequestForOperation(
        'GenerateOtp',
        true,
        DataServiceEntities.OtpStatusExtensionClass,
        'false',
        { bypassCache: 'get', returnEntity: 'DataServiceEntities.IOtpStatus' },
        {
            emailAddress: emailAddress
        }
    );
}

export function generateOtpAsync(context: IContext, emailAddress: string): AsyncResult<DataServiceEntities.IOtpStatus> {
    const request = generateOtpInput(emailAddress);
    return callActionOrExecute<DataServiceEntities.IOtpStatus>(request, context.callerContext);
}

function validateOtpQuery(): DataServiceQuery {
    return new DataServiceQuery();
}

export function validateOtpInput(emailAddress: string, otp: string): IDataServiceRequest {
    const query = validateOtpQuery();
    return query.createDataServiceRequestForOperation(
        'ValidateOtp',
        true,
        DataServiceEntities.OtpStatusExtensionClass,
        'false',
        { bypassCache: 'get', returnEntity: 'DataServiceEntities.IOtpStatus' },
        {
            emailAddress: emailAddress,
            otp: otp
        }
    );
}

export function validateOtpAsync(context: IContext, emailAddress: string, otp: string): AsyncResult<DataServiceEntities.IOtpStatus> {
    const request = validateOtpInput(emailAddress, otp);
    return callActionOrExecute<DataServiceEntities.IOtpStatus>(request, context.callerContext);
}

function updateCustomerEmailQuery(): DataServiceQuery {
    return new DataServiceQuery();
}

export function updateCustomerEmailInput(emailAddress: string): IDataServiceRequest {
    const query = updateCustomerEmailQuery();
    return query.createDataServiceRequestForOperation(
        'UpdateCustomerEmail',
        true,
        DataServiceEntities.OtpStatusExtensionClass,
        'false',
        { bypassCache: 'get', returnEntity: 'DataServiceEntities.IOtpStatus' },
        {
            emailAddress: emailAddress
        }
    );
}

export function updateCustomerEmailAsync(context: IContext, emailAddress: string): AsyncResult<DataServiceEntities.IOtpStatus> {
    const request = updateCustomerEmailInput(emailAddress);
    return callActionOrExecute<DataServiceEntities.IOtpStatus>(request, context.callerContext);
}
